import { render, staticRenderFns } from "./ErrorReasons.vue?vue&type=template&id=5afe0c94&scoped=true&"
import script from "./ErrorReasons.vue?vue&type=script&lang=js&"
export * from "./ErrorReasons.vue?vue&type=script&lang=js&"
import style0 from "./ErrorReasons.vue?vue&type=style&index=0&id=5afe0c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afe0c94",
  null
  
)

export default component.exports